(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	/* Ensure DOM is ready before initializing */
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', swiperInit);
	} else {
		swiperInit();
	}
})();
